// TODO: implement a better, more DRY global context
// (get inspiration here maybe https://dev.to/elisealcala/react-context-with-usereducer-and-typescript-4obm)

import {
	createContext,
	useState,
	useMemo,
	useContext,
	SetStateAction,
	Dispatch,
} from 'react';

/* TYPES */
type GdprServiceType = { [key: string]: string } & {
	isAccepted: boolean;
};
type GdprServicesType = {
	googletagmanager?: GdprServiceType;
	facebookpixel?: GdprServiceType;
	googlemaps?: GdprServiceType;
};

export interface GlobalContextData {
	navIsOpen: boolean;
	setNavIsOpen: Dispatch<SetStateAction<boolean>>;
	gdprServices: GdprServicesType;
	setGdprServices: Dispatch<SetStateAction<GdprServicesType>>;
}

/* CONTEXT */
const GlobalContext = createContext<GlobalContextData | undefined>(undefined);

export const useGlobalContext = () => {
	const ctx = useContext(GlobalContext);
	if (!ctx) {
		throw new Error(
			'useGlobalContext must be used within the PostsContext.Provider'
		);
	}
	return ctx;
};

export const useGlobalContextValue = (): GlobalContextData => {
	// Menu
	const [navIsOpen, setNavIsOpen] = useState(false);
	// GDPR Services
	const [gdprServices, setGdprServices] = useState({});

	return useMemo(
		() => ({
			navIsOpen,
			setNavIsOpen,
			gdprServices,
			setGdprServices,
		}),
		[navIsOpen, setNavIsOpen, gdprServices, setGdprServices]
	);
};

export default GlobalContext;
